import { cloudStorage } from '@telegram-apps/sdk';

export const getFromStore = async <T>(
  key: string,
): Promise<T | null | undefined> => {
  if (!key) {
    throw new Error('Key is undefined!');
  }

  if (!cloudStorage.getItem?.isAvailable()) {
    throw new Error('Cloud storage is unavailable!');
  }

  try {
    const raw = (await cloudStorage.getItem(key)) as unknown as Record<
      string,
      T
    >;
    return raw ? (raw[key] as T) : null;
  } catch (err) {
    console.error('[cloudStorage] getItem failed', err);
  }
};
